import './bootstrap';
import '../css/app.css';

import { createApp } from 'vue'; // Import Vue 3's createApp function
import OrganizePdf from './Components/OrganizePdf.vue';
import MergePdf from './Components/MergePdf.vue';
import SplitPdf from './Components/SplitPdf.vue';
import RotatePdf from './Components/RotatePdf.vue';
import CompressPdf from './Components/CompressPdf.vue';

const app = createApp({
    components: {
        OrganizePdf,
        MergePdf,
        SplitPdf,
        RotatePdf,
        CompressPdf
    },
});
app.mount('#app');
